import AttToken from "../../../helpers/attToken";
import { useEffect, useState } from "react";
import Tickets, { TicketsType } from "../../../service/Tickets";
import { toast } from "react-toastify";
import { AiOutlineCheck, AiOutlineClose } from "react-icons/ai";
import { ButtonsDiv, MotivoSpan, NameSpan } from "../style/AllNotificationsStyle";
import { trackEventMatomo } from "../../../helpers/matomo";
import { useTranslation } from "react-i18next";
import QueryFn from "../../../helpers/QueryFn";
import HeaderModal from "../../HeaderModal/HeaderModal";

type props = {
  open: boolean,
  setOpen: Function,
  chamados: TicketsType[] | undefined
};
const ticketsService = new Tickets();
const queryFn = new QueryFn();

export default function RedirectListModal({
  open,
  setOpen,
  chamados

}: props) {
  const [showAccpet, setShowAccept] = useState(true);
  const [showReject, setShowReject] = useState(true);
  const { t } = useTranslation('translation');

  const { mutate } = queryFn.useMutate('REDIRECT_TICKEST',
    async (action: 'rejeita' | 'aceita', chamadoId: string) => {
      const token = await AttToken();
      toast.warn(`${t('notifications.modals.performingAction')}`);
      if (token) {
        await ticketsService.redirecionaChamado(token, chamadoId, null, null, action);
        if (action === 'aceita') toast.success(`${t('notifications.modals.ticketAccepted')}`);
        else toast.success(`${t('notifications.modals.ticketRejected')}`);
      } else {
        toast.error(`${t('notifications.modals.errorPerformingAction')}`);
        setOpen(false);
      }
    });

  const close = () => {
    trackEventMatomo('modal redireciona chamado', 'click', 'buttob', 'fecha');
    setOpen(false);
  };

  const escape = (e: any) => {
    if (e.key === 'Escape') {
      close();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', escape, true);
  }, [escape]);

  return (
    <div className={`modal ${open ? "modal is-active" : "modal"}`}>
      <div className="modal-background" onClick={close} onKeyDown={(e) => escape(e)} />
      <div className="modal-card" style={{ height: '450px' }}>
        <HeaderModal headerTitle={t('notifications.modals.ticketsRedirected')} close={close} />
        <div className="modal-card-body">
          {chamados && chamados.map((ticket) => (
            <div style={{
              display: 'flex',
              justifyContent: 'space-around',
              alignItems: 'center',
              backgroundColor: '#f0f0f0',
              border: 'none',
              borderRadius: '0 0 20px 20px',
              margin: '10px',
              flexDirection: 'column',
            }}>
              <NameSpan>{ticket.nome.toLocaleLowerCase()}</NameSpan>
              <div style={{ marginTop: '5px', marginBottom: '10px', width: '90%', wordBreak: 'break-all' }}>
                <MotivoSpan>{t('notifications.modals.reasonForRedirecting')}</MotivoSpan>
                <span style={{ maxWidth: '70%' }}>{ticket.motivoEncaminhamento}</span>
              </div>
              <ButtonsDiv>
                <button
                  className="accept"
                  onMouseEnter={() => setShowReject(false)}
                  onMouseLeave={() => setShowReject(true)}
                  onClick={() => {
                    trackEventMatomo('modal redireciona chamado', 'click', 'buttob', 'redireciona');
                    mutate('aceita', ticket?.id as any);
                  }}
                  style={{ width: showAccpet ? '100%' : '5%' }}
                >
                  <AiOutlineCheck />
                </button>
                <button
                  className="reject"
                  onMouseEnter={() => setShowAccept(false)}
                  onMouseLeave={() => setShowAccept(true)}
                  onClick={() => {
                    trackEventMatomo('modal redireciona chamado', 'click', 'buttob', 'cancela');
                    mutate('rejeita', ticket.id as any);
                  }}
                  style={{ width: showReject ? '100%' : '5%' }}
                >
                  <AiOutlineClose />
                </button>
              </ButtonsDiv>
            </div>
          ))}
        </div>
      </div>
    </ div>
  );
}
